import { FeatureConfig } from '@cbre/feature-toggles';
import { LogLevel } from '@cbre/logger';
import base from './environment.base';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const featuresConfig: FeatureConfig = {
  tim: true,
  tenancy: true,
  'historical-stats': true,
  'tim-competing-tims': false,
  'wizard-creation': true,
  brand: true,
  // this flag removes NAICs input from on the fly company creation dialog
  'include-NAICS': true,
  // used to show/hide property view PV in stacking plan
  stackingPlanPropertyView: true,
  stackingPlanPropertyViewBuilding: true,
  stackingPlanPropertyViewElevators: true,
  stackingPlanPropertyViewLeaseInfo: true,
  stylishSummary: true,
  isPropertySetEnabled: true,
  sortCompanyContactsManually: true,
  isTypeOfLeaseEnable: true,
  // Availability Calculations New Columns and Logic
  availabilityNewGroups: true,
  // Historical Stats Changes for New Columns, Filter by Periods including Dowloading
  historicalStatChanges: true,
  // Historical Stats Changes to add PRoperty Sets including Downloading
  historicalStatPS: true,
  // Tourbook Enablement
  isTourbookReady: true,
};

export const environment = {
  ...base,
  production: false,
  baseUrl: 'https://dev2.marketiq.cbre.com:443/api', // ! no slash at the end required
  spmtBE: 'https://dev2.marketiq.cbre.com/api/datastack',
  host: 'https://dev2.marketiq.cbre.com',
  cepHost: 'https://dev.miq.cbre.com',
  e2eJson: 'dev',
  s3BucketUrl: 'https://dev2.marketiq.cbre.com/aws/',
  s3BucketTicketsUrl: 'https://dev2.marketiq.cbre.com/tickets/',
  s3BucketImagesUrl: 'https://dev2.marketiq.cbre.com/prop-images/',
  env: 'DEV2',
  logEnv: 'dev',
  logLevel: LogLevel.Error,
  debugActions: [],
  /** @deprecated */
  edpMultimediaURI: 'adv-multimedia-np',
  media: {
    originalLocationURI: '/prop-images/',
    thumbLocationURI: '/prop-images/thumb/',
    edpMultimediaKey: 'adv-multimedia-np',
  },
  globalListingsUrl: 'https://dev-dataentry.cbrelistings.com/miq/create/',
  featuresConfig,
  // Data Stack host strategy — 'elements' embeds <kads-spdm>; 'legacy' navigates
  // to /kads/data-management/:property_id. Sits at the env top level (not in
  // featuresConfig) so it can remain a string literal while featuresConfig
  // keeps its strict FeatureConfig (boolean | {value:boolean}) type.
  datastackIntegrationMode: 'elements' as const,
  cigConfig: {
    ciq_create_path: 'https://cbrecrm--mrdev.sandbox.lightning.force.com',
    ciq_path: 'https://cbrecrm--mrdev.sandbox.my.salesforce.com',
    // TODO: change credential's values
    CIQ_USER: 'cep.integration@cbre.com.crm.mrdev',
    CIQ_CLIENT_ID: '',
  },
  TourBookTemplates: {
    ComparisonView: '671cc392f565fb8587419b13', // v2.51.0
    PropertyAvailabilityDetailsView: '671d1570f565fb8587419b15', // v2.51.0
    TourBook: '671ef47dcc06855478cb6890', // v2.51.0
  },
  TemplateHubTourBookTemplates: {
    ComparisonView: '8eb620ac-d095-45c0-b6f5-ba9caed09135', //v2.63.0
    PropertyAvailabilityDetailsView: '9388844c-53ec-404c-8ff2-c039d766ac98', //v2.63.0
    TourBook: 'c5aa4408-e0a2-4c0a-8218-1934f360ebbf', //v2.63.0
  },
  // Dev[1], QA[2], UAT[3], STG[4]
  TemplateHubEnv: '1',
  PvSideBySideTemplates: {
    TemplafyId: '63d33eaaae1b0c696dbd2ac9',
    TemplateHubId: 'd34d92f0-a373-4afe-94b6-a346dce24c0b',
  },
  clarity: {
    projectId: 'ubq3izi126',
  },
  ReportGenerator: {
    FEPrefix: '/rmr/fe',
  },
  LeaseQC: {
    FEPrefix: '/leaseqc/web',
  },
  KADS: {
    FEPrefix: '/kads/web',
  },
  COSTAR_BASE_URL: 'https://product.costar.com/detail/all-properties',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
